module.exports = __webpack_public_path__ + "media/images/dummy-profile-2-1932a42d296b879071c58853e6c92919.jpeg";